import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import LoadingBar from 'react-redux-loading';
import ProtectedRoute from './components/routes/protectedRoute';
import Container from './components/container';
import Login from './components/auth/Login';
import Logout from './components/auth/Logout';
import NotFound from './components/notFound';
import Whoami from './components/whoami';
import GA from './utils/GoogleAnalytics';
import 'react-toastify/dist/ReactToastify.css';



const asyncImportCss = async () => {
  if (process.env.REACT_APP_API_URL.indexOf('test') !== -1) {
    await import('./styles/main-test.css');
  } else if (process.env.REACT_APP_API_URL.indexOf('dev') !== -1) {
    await import('./styles/main-dev.css');
  }
}

const App = () => {
  asyncImportCss();
  return(
    <React.Fragment>
      <LoadingBar />
      <ToastContainer />
      {GA.init() && <GA.RouteTracker />}
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/logout" component={Logout} />
        <ProtectedRoute path="/home" component={Container} />
        <ProtectedRoute path="/whoami" component={Whoami} />
        <Route path="/not-found" component={NotFound} />
        <Redirect from="/" exact to="/home" />
        <Redirect to="/not-found" />
      </Switch>
    </React.Fragment>
  )
};

export default App;
